(function () {
  var section = document.querySelector('[data-pcart]');
  if (!section) return;

  var itemsContainer = section.querySelector('[data-pcart-items]');

  /* Le format était codé en dur en « 44,99 $ » alors que Liquid rend ce que la
     boutique a configuré (« $44.99 » par défaut en CAD comme en USD). Le montant
     changeait donc de forme au premier clic sur +. On suit maintenant le format
     réel de la boutique. */
  var MONEY_FORMAT = section.dataset.moneyFormat || '${{amount}}';

  function group(intPart, sep) {
    return intPart.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }

  function formatMoney(cents) {
    if (typeof cents !== 'number' || isNaN(cents)) return '';
    return MONEY_FORMAT.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      var noDecimals = name.indexOf('no_decimals') !== -1;
      var value = (cents / 100).toFixed(noDecimals ? 0 : 2);
      var parts = value.split('.');
      var thousands = ',';
      var decimal = '.';

      if (name.indexOf('comma_separator') !== -1) { thousands = '.'; decimal = ','; }
      else if (name.indexOf('apostrophe_separator') !== -1) { thousands = "'"; }
      else if (name.indexOf('period_and_space_separator') !== -1) { thousands = ' '; }
      else if (name.indexOf('space_separator') !== -1) { thousands = ' '; decimal = ','; }

      var out = group(parts[0], thousands);
      if (parts[1]) out += decimal + parts[1];
      return out;
    }).replace(/<[^>]*>/g, '').trim();
  }

  function setBusy(lineEl, busy) {
    if (!lineEl) return;
    lineEl.classList.toggle('is-busy', busy);
  }

  function updateSummary(cart) {
    var sub = section.querySelector('[data-pcart-subtotal]');
    /* Sous-total et total lisaient la même valeur : avec une remise, le
       récapitulatif ne tombait pas juste. */
    if (sub) sub.textContent = formatMoney(cart.items_subtotal_price);

    /* querySelectorAll, pas querySelector : le total est affiché à deux
       endroits depuis l'ajout de la barre de caisse mobile. Au singulier,
       la barre gardait le montant du chargement et contredisait la carte
       après chaque +/−. */
    section.querySelectorAll('[data-pcart-total]').forEach(function (el) {
      el.textContent = formatMoney(cart.total_price);
    });

    var discountRow = section.querySelector('[data-pcart-discount-row]');
    var discount = section.querySelector('[data-pcart-discount]');
    if (discountRow) discountRow.hidden = !cart.total_discount;
    if (discount) discount.textContent = '− ' + formatMoney(cart.total_discount);

    /* Le compteur d'articles restait figé après un +/−. */
    var count = section.querySelector('[data-pcart-count]');
    if (count) {
      var n = cart.item_count;
      count.textContent = n === 0
        ? count.dataset.empty
        : n + ' ' + (n === 1 ? count.dataset.singular : count.dataset.plural);
    }
  }

  /* Barre de caisse mobile : on l'efface pendant que le vrai bouton du
     récapitulatif est à l'écran, sinon la même action s'affiche deux fois.

     Le repli est volontairement « barre visible » : sans IntersectionObserver,
     ou si ce code casse, on garde le bouton atteignable — c'est justement le
     problème qu'il corrige. Le CSS ne fait rien apparaître au-dessus de 900 px. */
  var stickyObserver = null;

  function bindStickyBar() {
    var bar = section.querySelector('[data-pcart-sticky]');
    var target = section.querySelector('[data-pcart-checkout]');
    if (stickyObserver) { stickyObserver.disconnect(); stickyObserver = null; }
    if (!bar || !target || typeof IntersectionObserver === 'undefined') return;

    /* Etat de depart calcule avant l'observation : sur un panier court le
       bouton est deja visible au chargement, et la barre aurait clignote. */
    var box = target.getBoundingClientRect();
    bar.classList.toggle('is-off', box.top < window.innerHeight && box.bottom > 0);

    stickyObserver = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-off', entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -24px 0px' });
    stickyObserver.observe(target);
  }

  function refreshSection() {
    fetch(window.location.pathname + '?section_id=proart-cart', { cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var fresh = temp.querySelector('.pcart');
        if (fresh) {
          section.innerHTML = fresh.innerHTML;
          itemsContainer = section.querySelector('[data-pcart-items]');
          /* innerHTML remplace la barre et le bouton observes : sans ce
             recablage, l'observateur pointe des noeuds detaches et la barre
             reste figee dans l'etat qu'elle avait avant le rafraichissement. */
          bindStickyBar();
        }
      })
      .catch(function () { window.location.reload(); });
  }

  bindStickyBar();

  function changeCart(line, qty, lineEl) {
    setBusy(lineEl, true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        /* /cart/change.js répond 422 avec {message, description} quand la quantité
           dépasse le stock. Cette réponse n'a pas de total_price : elle était traitée
           comme un panier valide et vidait les montants à l'écran. On repart alors
           de la vérité serveur. */
        if (!cart || typeof cart.total_price !== 'number') {
          setBusy(lineEl, false);
          refreshSection();
          return;
        }
        updateSummary(cart);
        if (qty === 0 || cart.item_count === 0) {
          refreshSection();
        } else {
          var qtyEl = lineEl ? lineEl.querySelector('[data-qty]') : null;
          var matchedItem = cart.items.find(function (it, i) { return (i + 1) === line; });
          if (qtyEl && matchedItem) qtyEl.textContent = matchedItem.quantity;
          var priceEl = lineEl ? lineEl.querySelector('.pcart-item__price') : null;
          if (priceEl && matchedItem) priceEl.textContent = formatMoney(matchedItem.final_line_price);
          setBusy(lineEl, false);
        }
        if (window.__proartUpdateCartCount) window.__proartUpdateCartCount(cart.item_count);
      })
      .catch(function () { setBusy(lineEl, false); window.location.reload(); });
  }

  section.addEventListener('click', function (e) {
    var inc = e.target.closest('.pcart-item__qty-btn.cart-item__qty-increase');
    var dec = e.target.closest('.pcart-item__qty-btn.cart-item__qty-decrease');
    var rm = e.target.closest('.pcart-item__remove');
    if (!inc && !dec && !rm) return;

    var lineEl = e.target.closest('[data-line]');
    if (!lineEl) return;
    var line = parseInt(lineEl.dataset.line, 10);
    var qtyEl = lineEl.querySelector('[data-qty]');
    var current = qtyEl ? parseInt(qtyEl.textContent, 10) : 0;

    e.preventDefault();
    if (rm) { changeCart(line, 0, lineEl); return; }
    if (inc) { changeCart(line, current + 1, lineEl); return; }
    if (dec) {
      if (current <= 1) { changeCart(line, 0, lineEl); }
      else { changeCart(line, current - 1, lineEl); }
    }
  });
})();
